(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('AuditLogDetailController', AuditLogDetailController);

    AuditLogDetailController.$inject = ['$scope', '$rootScope', 'entity', 'AuditLogService' ];

    function AuditLogDetailController($scope, $rootScope, entity, AuditLogService) {
        var vm = this;
        vm.auditLog = entity;
        vm.differences = [];
        vm.deletedEntities = [];
        // vm.getDeletedList = getDeletedList;
        vm.dashedName = null;

        // vm.getDeletedList();

        vm.auditLog.$promise.then(function () {
            vm.differences = splitChangesString();
            vm.dashedName = vm.auditLog.entityName.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();
        });

        function splitChangesString(){
            if (vm.auditLog.changes != null) {
                var splitString = vm.auditLog.changes.slice(0, -1).split("PROPERTY");
                splitString.splice(0, 1);
                return splitString;
            }
        }

        // function getDeletedList (){
        //     AuditLogService.loadByAction({action: 'DELETED'}, function (res) {
        //         var result = res.map(function (audit) {
        //             return {entityId: (audit.entityId), entityName: (audit.entityName)}
        //         });
        //         vm.deletedEntities = Array.from(new Set(result.map(JSON.stringify))).map(JSON.parse);
        //     });
        // }

        /**
         * disabilitato ui-sref su entity User dato che pagina user-management-detail non ha id come parametro
         * decidere se lasciare cosi o modificare User per recuperare login e fare funzione che costruisce ui-sref dal controller
         */
        // vm.checkIfAuditDeletedOrIsUser = function () {
        //     var found = false;
        //     vm.deletedEntities.forEach(function (entry) {
        //         if (!found) {
        //             found = ((entry.entityId === vm.auditLog.entityId && entry.entityName === vm.auditLog.entityName) || (vm.auditLog.entityName === 'User')) ;
        //         }
        //     });
        //     return found;
        // };

        var unsubscribe = $rootScope.$on('jotApp:AuditLogUpdate', function(event, result) {
            vm.auditLog = result;
        });

        $scope.$on('$destroy', unsubscribe);

    }
})();
